import {
  TRY_LOGIN_SUCCESS,
  TRY_LOGIN_FAIL,
  CLEAR_LOGIN,
  CLEAR_ERROR,
  LOGGED_IN,
  LOGGED_FAILD,
  NO_REG,
  BLACK_LIST,
  LOGOUT,
} from "./login.actions";

const initialState = {
  loginStatus:
    localStorage.getItem("accessToken") && localStorage.getItem("refreshToken")
      ? true
      : false,
  errorStatus: false,
  errorMsg: "",
  checklogin: false,
  wrongPass: false,
  phone: null,
};

function login(state = initialState, action) {
  switch (action.type) {
    case TRY_LOGIN_SUCCESS:
      return {
        ...state,
        checklogin: true,
        errorStatus: false,
        errorMsg: "",
        wrongPass: false,
        phone: localStorage.getItem("login") || null,
      };

    case TRY_LOGIN_FAIL:
      return {
        ...state,
        errorStatus: true,
        errorKey: action.payload.errorKey,
        checklogin: false,
        wrongPass: false,
        phone: null,
      };
    case CLEAR_LOGIN:
      return {
        ...state,
        checklogin: false,
        errorStatus: false,
        errorMsg: "",
        wrongPass: false,
        phone: null,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        errorStatus: false,
        errorMsg: "",
      };

    case LOGGED_IN:
      return {
        ...state,
        loginStatus: true,
        checklogin: false,
        errorStatus: false,
        errorMsg: "",
        wrongPass: false,
      };

    case LOGGED_FAILD:
      return {
        ...state,
        loginStatus: false,
        wrongPass: true,
        checklogin: true,
        phone: action.payload.phone || null,
        errorStatus: true,
        errorMsg: action.payload.message || "Неверный код",
      };

    case NO_REG:
      return {
        ...state,
        checklogin: false,
        errorStatus: true,
        errorMsg: "Пользователь не зарегистрирован",
        wrongPass: false,
        phone: null,
      };

    case BLACK_LIST:
      return {
        ...state,
        checklogin: false,
        errorStatus: true,
        errorMsg: "Пользователь заблокирован",
        wrongPass: false,
        phone: null,
      };

    case LOGOUT:
      return {
        ...initialState,
        loginStatus: false,
        checklogin: false,
        wrongPass: false,
        phone: null,
        userHash: false,
        preloader: false,
      };

    default:
      return state;
  }
}

export default login;
